module.exports = __webpack_public_path__ + "static/Logo_Rotschopf-23fc79ad2ce2f103f812086706c352de.svg";